export const getSDKScript = () => {
  //updateid
  // const sdkUrl = 'https://stage.id-envs.nbcuni.com/websdk/v2/identity-sdk.min.js';
  const sdkUrl = 'https://id.nbcuni.com/websdk/v2/identity-sdk.min.js';
  console.log('🔍 [scriptHelper] Loading SDK from:', sdkUrl);
  return sdkUrl;
};
